import { useState } from "react";
import { HiMenu, HiX } from "react-icons/hi";

export default function Navbar() {

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-50 backdrop-blur bg-zinc-950/70 border-b border-zinc-800">

      <div className="max-w-5xl mx-auto px-6 py-4 flex justify-between items-center">

        {/* LOGO */}

        <h1 className="text-xl font-bold">
          developwithmanish
        </h1>

        {/* DESKTOP MENU */}

        <div className="hidden md:flex gap-6 text-sm text-zinc-300">

          <a
            href="#skills"
            className="hover:text-white transition"
          >
            Skills
          </a>

          <a
            href="#projects"
            className="hover:text-white transition"
          >
            Projects
          </a>

          <a
            href="#contact"
            className="hover:text-white transition"
          >
            Contact
          </a>

        </div>

        {/* MOBILE BUTTON */}

        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden text-3xl"
        >
          {menuOpen ? <HiX /> : <HiMenu />}
        </button>

      </div>

      {/* MOBILE MENU */}

      {menuOpen && (

        <div className="md:hidden px-6 pb-6 flex flex-col gap-4 text-zinc-300">

          <a
            href="#skills"
            onClick={() => setMenuOpen(false)}
            className="hover:text-white transition"
          >
            Skills
          </a>

          <a
            href="#projects"
            onClick={() => setMenuOpen(false)}
            className="hover:text-white transition"
          >
            Projects
          </a>

          <a
            href="#contact"
            onClick={() => setMenuOpen(false)}
            className="hover:text-white transition"
          >
            Contact
          </a>

        </div>

      )}

    </nav>
  );
}